<div class="dashboard-card">
  <div class="card-header">
    <h4 class="card-title">About to Expiry</h4>
    <a class="view-all-link" href="#">View all</a>
  </div>
  <div class="card-content">
    <div *ngIf="isLoadingAboutToExpiry" class="card-loading">
      <div class="loading-spinner"></div>
      <span>Loading expiring soon data...</span>
    </div>
    <div *ngIf="!isLoadingAboutToExpiry && aboutToExpiryData.length === 0" class="empty-state-message">
      <i class="fa fa-hourglass-end empty-icon" aria-hidden="true"></i>
      <span>No products are nearing expiry in the selected date range.</span>
    </div>
    <ul *ngIf="!isLoadingAboutToExpiry && aboutToExpiryData.length > 0" class="expiring-list">
      <li class="expiring-list-item" *ngFor="let item of aboutToExpiryData">
        <div class="expiring-list-product">
          <img class="product-icon" src="assets/images/cabinet/product.png" alt="Product image">
        </div>
        <div class="expiring-list-details">
          <div class="expiring-list-title">{{ item.product_name }}<span *ngIf="item.batch_no">, {{ item.batch_no }}</span></div>
          <div class="expiring-list-meta">{{ item.store_name }} | {{ item.cabinet_name || '-' }}</div>
        </div>
        <div class="expiring-list-date">
          <img class="expiring-icon" src="assets/images/cabinet/expiring.svg" alt="Expiring icon">
          <span>{{ item.expiry_date }}</span>
        </div>
      </li>
    </ul>
  </div>
</div>
